// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"22c5a35a","164":"b858560c","609":"95aaf26c","625":"66d366fd","726":"6bfa36a1","750":"adf8bd95","805":"a65b5347","826":"926ba1da","844":"18d8772d","959":"b7d21ccf","965":"341edae1"}[chunkId] + ".chunk.js";
};